import React from 'react';
import { Button } from '@material-ui/core';

const WMSubmit = props => {
  return props.showReturnHomeButton ? (
    <Button
      className={props.classes.actionButton}
      style={props.submitButtonStyle}
      onClick={() => props.returnHome()}
    >
      Return Home
    </Button>
  ) : (
    <Button
      className={props.classes.actionButton}
      style={{
        ...props.submitButtonStyle,
        marginTop: '20px',
      }}
      disabled={props.disableOptions}
      onClick={props.onSubmit}
    >
      Submit
    </Button>
  );
};

export default WMSubmit;
